import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

interface IProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute = ({children}: IProtectedRouteProps) => {
    const {user} = UserAuth()
    if(!user) {
        return <Navigate to='/' />;
    } else {
        return <>{children}</>;
    }
  
};

export default ProtectedRoute;